<script setup lang="ts">
  defineOptions({ inheritAttrs: false, name: 'CPToggle' })

  import { HLToggle } from '@platform-ui/highrise'

  const props = defineProps({
    id: {
      type: String,
      required: true,
    },
  })

  // Component-owned token bridge intentionally takes precedence over consumer --n-* styles.
  const toggleStyles = {
    '--n-button-color': 'var(--cp-text-on-primary)',
    '--n-rail-color': 'var(--cp-border-500)',
    '--n-rail-color-active': 'var(--cp-primary-500)',
    '--n-rail-color-disabled': 'var(--cp-border-500)',
    '--n-opacity-disabled': '0.55',
  }
</script>

<template>
  <HLToggle
    v-bind="$attrs"
    :id="props.id"
    :style="toggleStyles"
    class="cp-toggle ring-primary ring-offset-surface ring-offset-2 focus-visible:ring-2"
  />
</template>

<style>
  .cp-toggle.n-switch--disabled .n-switch__rail,
  .cp-toggle.hr-toggle--disabled .n-switch__rail,
  .cp-toggle.hr-switch--disabled .n-switch__rail {
    background-color: var(--cp-border-500) !important;
  }

  .cp-toggle.n-switch--disabled.n-switch--active .n-switch__rail,
  .cp-toggle.hr-toggle--disabled.hr-toggle--checked .n-switch__rail,
  .cp-toggle.hr-switch--disabled.n-switch--active .n-switch__rail {
    background-color: color-mix(
      in oklab,
      var(--cp-primary-500) 40%,
      var(--cp-background-500)
    ) !important;
  }
</style>
